import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useEffect, useState } from "react";
import labels from "../../constants/Partner";
import configuration from "../../config";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { reactLocalStorage } from "reactjs-localstorage";

function Add({ history }) {
  const [isLoading, setIsLoading] = useState(false);
  const fieldArr = [
    {
      id: 0,
      title: "Available Balance",
      name: "wallet_balance",
      type: "TextInput",
      is_read_only: true,
    },
    {
      id: 1,
      title: "Enter Amount",
      name: "amount",
      type: "TextInput",
      is_number: true,
    },
  ];
  const [errors, setErrors] = useState({
    amount: 0,
  });
  const [fields, setFields] = useState({});
  const [bankDetails, setBankDetails] = useState(false);

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.amount) {
      error["amount"] = "Please enter amount";
      flag = false;
    } else if (fields.amount <= 0) {
      error["amount"] = "Amount must be greater than 0";
      flag = false;
    } else if (fields.balance < fields.amount) {
      error["amount"] = "Insufficient wallet balance";
      flag = false;
    }

    setErrors({ ...error });
    return flag;
  }
  const handleSubmit = () => {
    if (handleValidation()) {
      console.log(fields.wallet_balance,fields.amount);
      return false
      setIsLoading(true);
      configuration
        .postAPI({
          url: "sub-user/withdraw-request",
          params: { ...fields, user_type: "partner" },
        })
        .then((data) => {
          setIsLoading(false);
          if (data.status === 200) {
            toast.success("Withdrawal request sent successfully.", {
              onOpen: () => {
                setTimeout(() => {
                  history.push("/withdraw");
                }, 800);
              },
            });
          } else if (data.status === 404) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return toast.error(error.message);
        });
    }
  };
  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }

  useEffect(() => {
    let Id = reactLocalStorage.get("user_id");
    configuration
      .getAPI({ url: "sub-user/list", params: { user_id: Id } })
      .then((data) => {
        if (data.status === 200) {
          setFields(data.payload);
          if (
            !data.payload.bank_detail ||
            !data.payload.bank_detail.account_number ||
            !data.payload.bank_detail.bank_name
          ) {
            setBankDetails(true);
          }
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }, []);
  return (
    <>
      <Loader isOpen={isLoading} />
      <Breadcrumb module={labels.editPartner} />
      <AddEditSection
        title="Request Payout"
        path="/withdraw"
        fields={fieldArr}
        fieldValue={fields}
        fieldError={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        bankDetails={bankDetails}
      />
    </>
  );
}

export default Add;
